import {
  $WINDOW,
  HIDDEN_CLASS,
  L_TABLET_WIDTH,
  SHOW_CLASS,
} from "../lib/constants";
import { runFnByWinResize, smoothScrollTo } from "../lib/utils";

const SHOW_DOC_CLASS = "show-doc";
const HIDE_DOC_CLASS = "hide-doc";

export const copyPreviewImgToThumbsSlides = () => {
  const $slideImages = $(".js-swiper-slide");
  const $thumbsWrapper = $(".js-boiler-sls-thumbs-wrapper");
  const $thumbsContainer = $(".boiler-sls__thumbs-container");

  if ($slideImages.length && $slideImages.length > 1) {
    $thumbsContainer.addClass(SHOW_CLASS);

    $.each($slideImages, function (i, el) {
      const $slide = $(el);
      const thumbsSlide = $slide
        .clone()
        .removeClass()
        .addClass(
          "swiper-slide boiler-sls-thumbs__slide" +
            " js-boiler-sls-thumbs-slide"
        );
      const thumbsSlideImg = thumbsSlide
        .find("img")
        .removeClass()
        .addClass("boiler-sls-thumbs__slide-img");

      if (i === 0) {
        thumbsSlide.addClass("swiper-slide-thumb-active");
      }

      thumbsSlide.html(
        `<div class="boiler-sls-thumbs__slide-img-container">${thumbsSlideImg[0].outerHTML}</div>`
      );
      $thumbsWrapper.append(thumbsSlide);
    });
  } else {
    $thumbsContainer.hide();
  }
};

const toggleShowBoilerDocs = () => {
  const $docs = $(".js-boiler-info-docs");
  const $doc = $docs.find(".js-boiler-info-docs-row");
  const $toggleShowDocBtn = $docs.find(".js-boiler-info-docs-show-btn");

  const hideSomeDocs = () => {
    $.each($doc, function (i, el) {
      const $el = $(el);

      if (i > 3) {
        $el.addClass(HIDDEN_CLASS);
      }
    });
  };

  if ($doc.length > 4) {
    hideSomeDocs();
    $toggleShowDocBtn.addClass(SHOW_CLASS);

    $toggleShowDocBtn.on("click", function () {
      $toggleShowDocBtn.toggleClass(SHOW_DOC_CLASS).toggleClass(HIDE_DOC_CLASS);

      if ($toggleShowDocBtn.hasClass(SHOW_DOC_CLASS)) {
        $toggleShowDocBtn.text("Скрыть все файлы");
        $doc.removeClass(HIDDEN_CLASS);
      }

      if ($toggleShowDocBtn.hasClass(HIDE_DOC_CLASS)) {
        hideSomeDocs();
        $toggleShowDocBtn.text("Показать все файлы");
        smoothScrollTo($docs[0].offsetTop - 100);
      }
    });
  } else {
    $toggleShowDocBtn.removeClass(SHOW_CLASS);
  }
};

const transferBonusBlockToTabsDock = () => {
  const $bonusDock = $('[data-dock="bonus"]');
  const $boilerInfo = $(".js-boiler-info");
  const $boilerTabs = $(".js-boiler-info-tabs-shell");

  if ($WINDOW.width() > L_TABLET_WIDTH) {
    $boilerInfo.after($bonusDock);
  } else {
    if ($boilerTabs.length) {
      $boilerTabs.after($bonusDock);
    }
  }
};

export const productDetailFns = () => {
  toggleShowBoilerDocs();
  transferBonusBlockToTabsDock();
  runFnByWinResize(transferBonusBlockToTabsDock, L_TABLET_WIDTH);
};
